import React from "react";
import styles from './Spinners.module.css';
import { ReactComponent as Logo} from '../../imgs/vP_01.svg';
import SpinnerSVG from "./SpinnerSVG";

export default function Spinners({data,spin}){
    const {topText1,topText2,bottomText1,bottomText2,imgNo} = data
    return (
        <div className={styles.container}>
            <div className={styles.top} style={{opacity: spin === 0? 1 : 0}}>
                <h6>{topText1}<br/>{topText2}</h6>
            </div>
            <div className={`${spin === 0? styles.spinnerContainerWithBorder : styles.spinnerContainer}`}>
                <SpinnerSVG imgNo={imgNo} spin={spin}/>
            </div>
            <div className={styles.bottom} style={{opacity: spin === 0? 1 : 0}}>
                <h6>{bottomText1}<br/>{bottomText2}</h6>
            </div>
        </div>
    )
}